/**
 * Returns the progress as a percentage (0–100), clamped within this range.
 * If targetValue is not finite, non-positive, or currentValue is not finite, returns 0 to avoid division errors.
 */
export const getBadgeProgressPercentage = ({
  currentValue,
  targetValue,
}: {
  currentValue: number;
  targetValue: number;
}): number => {
  if (!Number.isFinite(targetValue) || targetValue <= 0 || !Number.isFinite(currentValue)) {
    return 0;
  }

  const percentage = (currentValue / targetValue) * 100;
  const clampedPercentage = Math.min(100, Math.max(0, percentage));

  return clampedPercentage;
};
